import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/petsShopLab2022/banner.jpg'
import navColor from '../../assets/petsShopLab2022/nav/color.jpg'
import navBgFixed from '../../assets/petsShopLab2022/nav/nav_bg_fixed.png'

import far from '../../assets/petsShopLab2022/nav/far.png'
import son1 from '../../assets/petsShopLab2022/nav/son1.png'
import son2 from '../../assets/petsShopLab2022/nav/son2.png'
import son3 from '../../assets/petsShopLab2022/nav/son3.png'
import son4 from '../../assets/petsShopLab2022/nav/son4.png'
import son5 from '../../assets/petsShopLab2022/nav/son5.png'
import son6 from '../../assets/petsShopLab2022/nav/son6.png'
import son7 from '../../assets/petsShopLab2022/nav/son7.png'
import son8 from '../../assets/petsShopLab2022/nav/son8.png'
import son9 from '../../assets/petsShopLab2022/nav/son9.png'
import son10 from '../../assets/petsShopLab2022/nav/son10.png'
import son11 from '../../assets/petsShopLab2022/nav/son11.png'
import son12 from '../../assets/petsShopLab2022/nav/son12.png'
import son13 from '../../assets/petsShopLab2022/nav/son13.png'
import son14 from '../../assets/petsShopLab2022/nav/son14.png'
import son15 from '../../assets/petsShopLab2022/nav/son15.png'
import son16 from '../../assets/petsShopLab2022/nav/son16.png'
import son17 from '../../assets/petsShopLab2022/nav/son17.png'
import son18 from '../../assets/petsShopLab2022/nav/son18.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(165.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(165.5),
    backgroundImage: 'none',
  },
  navCtnFixed: {
    height: calcRemFn(165.5),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${calcRemFn(10)} ${calcRemFn(10)} ${calcRemFn(8)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(87.5),
    height: calcRemFn(47),
    padding: `0`,
    opacity: 0
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: `0`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(72.5),
    height: calcRemFn(25),
    padding: `${calcRemFn(16)} ${calcRemFn(12)}`
  }
}

const navData = {
  component: NTopNBottom,
  className: 'petsShopLab2022',
  top: [
    {
      key: 'top1',
      show: true,
      img: far,
      img_actived: far,
    },
    {
      key: 'top2',
      show: true,
      img: far,
      img_actived: far,
    },
    {
      key: 'top3',
      show: true,
      img: far,
      img_actived: far,
    },
    {
      key: 'top4',
      show: true,
      img: far,
      img_actived: far,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4,
        style: {
          padding: `${calcRemFn(16)} ${calcRemFn(0)}`
        }
      },
      {
        key: '_i2',
        show: true,
        img: son5,
        img_actived: son5,
        style: {
          padding: `${calcRemFn(16)} ${calcRemFn(0)}`
        }
      },
      {
        key: '_i3',
        show: true,
        img: son6,
        img_actived: son6,
        style: {
          padding: `${calcRemFn(16)} ${calcRemFn(0)}`
        }
      },
      {
        key: '_i4',
        show: true,
        img: son7,
        img_actived: son7,
        style: {
          padding: `${calcRemFn(16)} ${calcRemFn(0)}`
        }
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son8,
        img_actived: son8,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(1)} ${calcRemFn(2)} ${calcRemFn(76.5)}`
        }
      },
      {
        key: '_i2',
        show: true,
        img: son9,
        img_actived: son9,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(1)}`
        }
      },
      {
        key: '_i3',
        show: true,
        img: son10,
        img_actived: son10,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(76.5)} ${calcRemFn(2)} ${calcRemFn(0)}`
        }
      },
      {
        key: '_i4',
        show: true,
        img: son11,
        img_actived: son11,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(1)}`
        }
      },
      {
        key: '_i5',
        show: true,
        img: son12,
        img_actived: son12,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(1)}`
        }
      }
    ],
    top4: [
      {
        key: '_i1',
        show: true,
        img: son13,
        img_actived: son13,
        style: {
          padding: `${calcRemFn(2)} 0 ${calcRemFn(2)} ${calcRemFn(76.5)}`
        }
      },
      {
        key: '_i2',
        show: true,
        img: son14,
        img_actived: son14,
        style: {
          padding: `${calcRemFn(2)} 0`
        }
      },
      {
        key: '_i3',
        show: true,
        img: son15,
        img_actived: son15,
        style: {
          padding: `${calcRemFn(2)} ${calcRemFn(76.5)} ${calcRemFn(2)} 0`
        }
      },
      {
        key: '_i4',
        show: true,
        img: son16,
        img_actived: son16,
        style: {
          padding: `${calcRemFn(2)} 0`
        }
      },
      {
        key: '_i5',
        show: true,
        img: son17,
        img_actived: son17,
        style: {
          padding: `${calcRemFn(2)} 0`
        }
      },
      {
        key: '_i6',
        show: true,
        img: son18,
        img_actived: son18,
        style: {
          padding: `${calcRemFn(2)} 0`
        }
      }
    ]
  }
}

const top1Prod = 106701
const top2Prod = 106702
const top3Prod = 106703
const top4Prod = 106704


const pictureList = [
  {
    key: '1_1',
    picNum: 2,
    pid: top1Prod
  },
  {
    key: '1_2',
    picNum: 1,
    pid: top1Prod
  },
  {
    key: '1_3',
    picNum: 1,
    pid: top1Prod
  },
  {
    key: '2_1',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_2',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_3',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_4',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '3_1',
    picNum: 1,
    pid: top3Prod
  },
  {
    key: '3_2',
    picNum: 1,
    pid: top3Prod
  },
  {
    key: '3_3',
    picNum: 1,
    pid: top3Prod
  },
  {
    key: '3_4',
    picNum: 1,
    pid: top3Prod
  },
  {
    key: '3_5',
    picNum: 1,
    pid: top3Prod
  },
  {
    key: '4_1',
    picNum: 1,
    pid: top4Prod
  },
  {
    key: '4_2',
    picNum: 1,
    pid: top4Prod
  },
  {
    key: '4_3',
    picNum: 1,
    pid: top4Prod
  },
  {
    key: '4_4',
    picNum: 1,
    pid: top4Prod
  },
  {
    key: '4_5',
    picNum: 1,
    pid: top4Prod
  },
  {
    key: '4_6',
    picNum: 1,
    pid: top4Prod
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/petsShopLab2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/petsShopLab2022/ctn/1_0_1.jpg')
  ],
})

const topDiff = {
  firstSon: '_i1',
  top1_i1: 30,
  top1_i2: 15,
  top1_i3: 20,
  top2_i1: 50,
  top2_i2: 20,
  top2_i3: 20,
  top2_i4: 20,
  top3_i1: 55,
  top3_i2: 20,
  top3_i3: 20,
  top3_i4: 20,
  top3_i5: 30,
  top4_i1: 40,
  top4_i2: 20,
  top4_i3: 20,
  top4_i4: 20,
  top4_i5: 20,
  top4_i6: 20
}

export default {
  title: '宠物照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
